// src/services/feedback-api.ts

import api from './api';

export interface FeedbackContext {
  pageUrl?: string;
  pagePath?: string;
  previousPath?: string;
  entityType?: string;
  entityId?: string;
  viewport?: string;
  isMobile?: boolean;
  theme?: string;
  userAgent?: string;
  appVersion?: string;
  clientTimestamp?: string;
}

export interface FeedbackPayload {
  rating?: 'up' | 'down';
  message?: string;
  context?: FeedbackContext;
}

export const feedbackApi = {
  // silenceToast: the widget renders its own inline success/error state, so we
  // suppress the global 4xx toast for this request.
  submit: async (payload: FeedbackPayload): Promise<void> => {
    await api.post('/api/feedback', payload, { silenceToast: true });
  },
};
